import { createReducer, Action, on } from '@ngrx/store';
import {
    createFormGroupState,
    onNgrxForms,
    updateGroup,
    onNgrxFormsAction,
    SetValueAction,
    wrapReducerWithFormStateUpdate,
    validate,
} from 'ngrx-forms';
import { ITfnState, TfnModel } from './state';
import { ResetDataSavedAction, SaveTfnResponseAction } from './actions';
import { required, requiredTrue } from 'ngrx-forms/validation';

const formName = 'tfn';

const defaultState: ITfnState = {
    form: createFormGroupState(formName, new TfnModel()),
    dataSaved: false
};

const validateTfn = updateGroup<TfnModel>({
    tfn: validate(required),
    tfnAgreement: validate(requiredTrue),
});

const reducer = createReducer(
    defaultState,
    onNgrxForms(),
    onNgrxFormsAction(SetValueAction, (state, _action) => {
        return state;
    }),
    on(SaveTfnResponseAction, (state) => {
        return {
            ...state,
            dataSaved: true
        }
    }),
    on(ResetDataSavedAction, (state) => {
        return {
            ...state,
            dataSaved: false
        }
    }),
);

const editTfnVerificationDataFormState = wrapReducerWithFormStateUpdate(
    reducer,
    s => s.form,
    validateTfn
)

export function tfnReducer(state: any | undefined, action: Action) {
    return editTfnVerificationDataFormState(state, action);
}
